export const pvqForeignBornDocumentsCivil = {
  heading: {
    citizenshipStatus: 'What is their United States citizenship status?',
    documentNumber:
    'What is the document number on the form? (This is not the form number. The document number may be listed as a registration number, serial number, or other number distinct to the person.)',
    documentExpiration: 'What is the expiration date of this document?',
    serialNumber: 'What is the serial number on the document? (This is typically the number in the top right-hand corner of the document, often in red ink.)',
  },
  para: {
    bornToUSParents: 'What document do they have proving they are a U.S. citizen born abroad?',
    naturalized: 'What document do they have proving they are a naturalized U.S. citizen?',
    derived: 'What document do they have proving they are a derived U.S. citizen?',
    notCitizen: 'What document do they have proving they are authorized to be in the U.S.?',
    residence: 'What is their residence status?',
    other: 'Other',
    none: 'None',
  },
  bornToUSParents: {
    label: {
      fs240: 'Form FS-240 (Consular Report of Birth Abroad)',
      ds1350: 'DS 1350 (Certificate of Report of Birth)',
      fs545: 'Form FS-545 (Certificate of Birth Abroad)',
      n560: 'Form N-560 or Form N-561 (Certificate of Citizenship)',
      other: 'Other'
    },
  },
  naturalized: {
    label: {
      certificateOfNaturalization: 'Form N-550 or Form N-570 (Certificate of Naturalization)',
      permanentResident:
        'Form I-551 (Permanent Resident Card/Resident Alien Card)',
      mriv: 'Form I-551 (Machine Readable Immigrant Visa (MRIV))',
      other: 'Other',
    },
    certificate: {
      alien: 'What is their U.S. Alien Registration Number?',
      alienLabel:
      '• You can find their Alien Registration Number on their Certificate of Naturalization (N-550 or N-570). It is a 7- to 9-digit number typically listed as the "USCIS Registration No.", "INS Registration No.", "CIS Registration No." It is NOT the "No." (short for number) in the top right hand corner often seen in red ink.',
      naturalization: 'What is their Naturalization Certificate Number or Naturalization Number?',
      naturalizationLabel:
      '• This is the "No." (short for number) in the top right hand corner of their Certificate of Naturalization (N-550 or N-570). It is often in red ink.'
    },
    permanent: {
      alien: 'What is their U.S. Alien Registration Number?',
      alienLabel:
      '• You can find their Alien Registration Number on their Permanent Resident Card/Resident Alien Card (Form I-551). It is a 7- to 9-digit number typically listed as the "A#", "INS A#", "Alien Number", or "USCIS#". On the Machine Readable Immigrant Visa (MRIV), it is the "Registration Number".',
    }
  },
  derived: {
    label: {
      certificateOfCitizenship: 'Certificate of Citizenship (Form N-560 or Form N-561)',
      permanentResident:
        'Permanent Resident Card/Resident Alien Card (Form I-551)',
      mriv: 'Machine Readable Immigrant Visa (MRIV)',
      other: 'Other',
    },
    certificate: {
      alien: 'What is their U.S. Alien Registration Number?',
      alienLabel:
      '• You can find their Alien Registration Number on their Certificate of Citizenship (Form N-560 or Form N-561). It is the 7- to 9-digit number typically listed as the "USCIS Registration No.", "CIS Registration No.", or "INS Registration No.".',
      citizenship: 'What is their Citizenship Certificate Number/Citizenship Number?',
      citizenshipLabel:
      '• This is the "No." (short for number) in the top right hand corner of their Certificate of Citizenship (Form N-560 or Form N-561). It is often in red ink.'
    },
    permanent: {
      alien: 'What is their U.S. Alien Registration Number?',
      alienLabel:
      '• You can find their Alien Registration Number on their Permanent Resident Card/Resident Alien Card (Form I-551). It is a 7- to 9-digit number typically listed as the "A#", "INS A#", "Alien Number", or "USCIS#". On the Machine Readable Immigrant Visa (MRIV), it is the "Registration Number".',
    }
  },
  notCitizen: {
    label: {
      livesInUnitedStates: 'Do they live in the U.S.?',
      permanentResident: 'I-551 Permanent Resident',
      employmentAuthorization: 'I-766 Employment Authorization',
      mriv: 'Machine Readable Immigrant Visa (MRIV)',
      arrivalDepartureRecord: 'I-94 Arrival-Departure Record',
      visa: 'U.S. Visa (Red foil number)',
      nonImmigrantStudent: 'I-20 Certificate of Eligibility for Non-Immigrant-F1-Student',
      exchangeVisitor: 'DS-2019 Certificate of Eligibility of Exchange Visitor-J1-Status',
      other: 'Other',
    },
    firstThree: {
      alien: 'What is their U.S. Alien Registration Number?',
      alienLabel:
      '• You can find their Alien Registration Number on their Permanent Resident Card/Resident Alien Card (Form I-551) or on their Employment Authorization Card (Form I-766), as applicable. Their Alien Registration Number may be listed as the "A#", "A" number, "INS A#", "Alien Number", or "USCIS#". On the Machine Readable Immigrant Visa (MRIV) Form I-551, it is the "Registration Number".',
    },
    otherLabels: {
      title: 'What is the title of the form?',
      documentNumber: 'What is the document number?',
      i94:
      '• For the Form I-94, list the 11-digit number labeled either "Admission Number", "Departure Number", "Admission Record (I-94) Number", or "I-94#". Or, they may have an "Admission Stamp" in their unexpired Foreign Passport. If this is the case, also list their Passport Number and the Country that issued the passport.',
      visa:
      '• For the U.S. Visa Card (nonimmigrant visa) -- the visa number, also called a visa foil number, is a red number that is generally printed on the bottom right corner of newer visa documents. In most cases, the U.S. visa number contains eight numeric characters. In some cases, the number contains one letter followed by seven numeric characters.',
      i20:
      '• For the Form I-20, list the "SEVIS ID" number near the top left or top right corner of the document (depending on the document version). All SEVIS ID numbers start with the letter N. If they also have an "Admission Number" on their Form I-20 document, list this number as well (this is their Form I-94 number).',
      ds2019: '• For the Form DS-2019, list the number on the top right hand side of the page in the box above the barcode. This is the SEVIS number. All SEVIS ID numbers start with the letter N.',
    },
  },
  other: {
    label: {
      other: 'Other (Provide explanation)',
    },
  },
  sf85p: {
    label: {
      citizenship: 'U.S. Certificate of Citizenship',
      passport: 'U.S. Passport (current or most recent)',
      alien: 'Alien registration',
      certificateOfNaturalization: 'U.S. Certificate of Naturalization',
    },
  },
  none: {
    label: {
      none: 'None (Provide explanation)',
    },
  },
};
